import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';

const nomenclature = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getNomenclatureHistory: builder.query<any, PayloadRequest>({
      query: ({ id }) => ({
        url: `/v1/nomenclature/${id}/history`,
      }),
    }),
  }),
});

export const { useLazyGetNomenclatureHistoryQuery } = nomenclature;
